import React from 'react';
import withStyles from 'react-jss';
import { useTranslation } from 'react-i18next';

const linkStyles = {
  color: (props) => ({
    color: props.color,

    '&:hover': {
      backgroundColor: 'white',
      textDecoration: 'underline',
      color: props.color,
    },
  }),
};

function ClearAll(props) {
  const { handleClearAllSelected } = props;
  const { t } = useTranslation();

  return (
    <button
      className={[
        'ecap-clear-all-link',
        props.classes.color,
        props.overRideStyle,
      ].join(' ')}
      onClick={() => {
        handleClearAllSelected();
      }}
      type="button"
      data-cy="ecap-clear-all-link"
    >
      {t('Clear All Sections')}
    </button>
  );
}

export default withStyles(linkStyles)(ClearAll);
